import { UPLOAD_BUTTON_LABEL } from '../../constants'
import { TextSmall } from '../typography'

const CreationUploadTerms = () => (
    <TextSmall>
        By clicking &quot;{UPLOAD_BUTTON_LABEL}&quot; you agree to our{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer">
            Terms of Service
        </a>
        ,{' '}
        <a href="/community-guidelines" target="_blank" rel="noopener noreferrer">
            Community Guidelines
        </a>
        , and our{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
        </a>
        .
    </TextSmall>
)

export default CreationUploadTerms
